const notSelector = ':not([tabindex="-1"]):not([disabled]):not([hidden])';
export const focusableElementsSelector = `button${notSelector}, [href]${notSelector}, input${notSelector}, select${notSelector}, textarea${notSelector}, [tabindex]${notSelector}, [contentEditable=true]${notSelector}`;

export const alphabet = 'a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z,æ,ø,å'.split(',');

export const getFocusableArray = (el: HTMLElement) =>
    Array.from(el?.querySelectorAll<HTMLElement>(focusableElementsSelector) ?? []);
